import React from 'react';
import PropTypes from 'prop-types';
import { Sector } from 'recharts';

import * as S from './styled';

const ActiveSector = ({
  cx,
  cy,
  innerRadius,
  outerRadius,
  cornerRadius,
  startAngle,
  endAngle,
  fill,
  payload,
  showTotal
}) => {
  const labelSize = innerRadius * 2 - (outerRadius - innerRadius);

  return (
    <g>
      {!showTotal && (
        <foreignObject height={labelSize} width={labelSize} x={cx - labelSize / 2} y={cy - labelSize / 2} dy={-10}>
          <S.LabelWrapper>
            <S.Number>
              {payload.prefix || null}
              {payload.value}
              {payload.suffix || null}
            </S.Number>
            <S.Label>{payload.name}</S.Label>
          </S.LabelWrapper>
        </foreignObject>
      )}
      <Sector
        cursor="pointer"
        cx={cx}
        cy={cy}
        innerRadius={innerRadius - 2}
        outerRadius={outerRadius + 2}
        cornerRadius={cornerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

ActiveSector.propTypes = {
  showTotal: PropTypes.bool,
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired,
  innerRadius: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired,
  cornerRadius: PropTypes.number,
  startAngle: PropTypes.number.isRequired,
  endAngle: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  payload: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    prefix: PropTypes.any,
    suffix: PropTypes.any
  }).isRequired
};

export default ActiveSector;
